import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = async () => {
        const token = localStorage.getItem("dq_token");
        if (!token) {
            setLoading(false);
            return;
        }
        try {
            const r = await api.get("/auth/me");
            setUser(r.data);
        } catch {
            localStorage.removeItem("dq_token");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMe();
    }, []);

    const loginWithToken = (token, u) => {
        localStorage.setItem("dq_token", token);
        setUser(u);
    };

    const logout = () => {
        localStorage.removeItem("dq_token");
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthContext.Provider value={{ user, loading, loginWithToken, logout, token: () => localStorage.getItem("dq_token") }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
